import React from 'react';
import { useController } from 'react-hook-form';
import Checkbox from 'components/shared/Checkbox';
import './CheckboxField.css';

function CheckboxField({ name, label }) {
  const {
    field: { value, onChange }
  } = useController({ name });
  const handleChange = () => {
    onChange(!value);
  };

  return (
    <div className="CheckboxField_Container">
      <Checkbox isChecked={value} onChange={handleChange} />
      <label htmlFor={name} className="CheckboxField_Label" onClick={onChange}>
        {label}
      </label>
    </div>
  );
}

export default CheckboxField;
